/** Pure formatting helpers shared across multiple tab components. */

export function formatW(w: number): string {
  return Math.abs(w) >= 1000
    ? (w / 1000).toFixed(2) + ' kW'
    : w.toFixed(0) + ' W';
}

export function formatKwh(kwh: number): string {
  return (kwh || 0).toFixed(2) + ' kWh';
}

export function fmtDate(dateStr: string, lang: string): string {
  if (!dateStr || dateStr === '?') return dateStr;
  const d = new Date(dateStr);
  const locale = lang === 'de' ? 'de-DE' : 'en-GB';
  return d.toLocaleDateString(locale, { weekday: 'short', day: '2-digit', month: '2-digit' });
}

export function autarkieColor(pct: number): string {
  if (pct >= 80) return 'text-success';
  if (pct >= 50) return 'text-warning';
  return 'text-danger';
}

export function fmtMonth(ym: string, lang: string): string {
  const d = new Date(ym + '-01');
  const locale = lang === 'de' ? 'de-DE' : 'en-GB';
  return d.toLocaleDateString(locale, { month: 'long' });
}

export function fmtMonthShort(ym: string, lang: string): string {
  const d = new Date(ym + '-01');
  const locale = lang === 'de' ? 'de-DE' : 'en-GB';
  return d.toLocaleDateString(locale, { month: 'short' });
}
